import React from 'react';
import { Badge } from 'react-bootstrap';

export interface LomavisBadge1Props {
  /** Unique identifier for this badge */
  id: string;

  /** Text shown inside the badge */
  title: string;

  /** Bootstrap variant (e.g. "primary", "success"). Optional if color is given. */
  variant?: string;

  /** Custom color code (e.g. "#34BA12", "rgb(0, 200, 150)"). */
  color?: string;

  /** Callback when delete (x) is clicked. Sends back the id */
  onDelete?: (id: string) => void;

  /** Optional custom className */
  className?: string;
}

/**
 * Atoms: LomavisBadge1
 */
export const LomavisBadge1: React.FC<LomavisBadge1Props> = ({
  id,
  title,
  variant,
  color,
  onDelete,
  className = ''
}) => {
  // Prefer custom color if provided
  const style = color ? { backgroundColor: color, color: '#fff' } : undefined;

  return (
    <span>
      <Badge
        bg={color ? '' : (variant as any)}
        className={`d-flex align-items-center gap-1 justify-content-between ${className}`}
        style={{
          backgroundColor: color ?? '',
          ...style,
          whiteSpace: 'normal', // ✅ allow line breaks
          wordBreak: 'break-word', // ✅ break long words
          overflowWrap: 'anywhere' // ✅ break anywhere if needed
        }}
      >
        {title}
        {onDelete && (
          <button
            type="button"
            className="btn-close btn-close-white ms-1"
            aria-label="Remove badge"
            style={{ fontSize: '0.5rem' }}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(id);
            }}
          />
        )}
      </Badge>
    </span>
  );
};
